// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7aa72f2","501":"e80b465e"}[chunkId] + ".chunk.js";
};